import { KpiCard } from "@/components/KpiCard";
import { formatMoneyWhole } from "@/lib/format";
import { useHomeShared } from "./HomeShared";
import "./CashTile.css";

/**
 * ef-061-4 — the Home "Cash and income" tile: Cash on hand (the hero) and Net farm income, the same two live
 * ledger figures Home has always shown (the figure is the ledger balance plus the live delta; null until the
 * ledger answers, rendered "—" — never a plausible constant). Both read the shared Home state, so the live-wall
 * beat (a visitor entry moves Cash on hand) works whichever other tiles are mounted.
 */
export function CashTile() {
  const { liveCashOnHand, liveNetFarmIncome, feedTransport, kpiFlashDelta } = useHomeShared();
  return (
    <div className="cash-tile">
      <KpiCard
        variant="hero"
        label="Cash on hand"
        value={liveCashOnHand === null ? "—" : formatMoneyWhole(liveCashOnHand)}
        detail="From the ledger · moves on today's entries"
        live
        /* The dot must not outlive the feed — see KpiCard's `stale`. */
        stale={feedTransport !== "live"}
        flashDelta={kpiFlashDelta}
      />
      <KpiCard
        label="Net farm income"
        value={liveNetFarmIncome === null ? "—" : formatMoneyWhole(liveNetFarmIncome)}
        detail="Year to date, from the ledger"
        live
        stale={feedTransport !== "live"}
        flashDelta={kpiFlashDelta}
      />
    </div>
  );
}
